import { Component, OnInit } from "@angular/core";
import { UtilsService } from "../../../services/utils.service";
import {
  IModalDialog,
  IModalDialogOptions,
  IModalDialogButton,
} from "ngx-modal-dialog";
import { ComponentRef } from "@angular/core";
import { ApiService } from '../../../services/api.service';
import { Product, ProductType } from '../../../models/product';

@Component({
  selector: "alg-bill-modal",
  templateUrl: "./alg-bill-modal.component.html",
  styleUrls: ["./alg-bill-modal.component.scss"],
})
export class AlgBillModalComponent implements OnInit {
  actionButtons: IModalDialogButton[];
  public product: Product;
  public isLight = false;
  public isGas = false;
  public luceEgas = false;

  constructor(private utils: UtilsService, private api: ApiService) {
    this.actionButtons = [
      { text: '', buttonClass: 'alg-btn-close', onAction: () => {
        this.utils.abilityOverflow();
        return true;
      }}
    ];
    
  }

  ngOnInit() {
    this.api.currentOnboarding.combineLatest(
      this.api.currentProduct
    ).subscribe(([onboarding, product]) => {
      this.genFormControlModal(product);
      this.product = product;
    });
  }

  private genFormControlModal(product: Product) {
    this.product = product;
    this.isLight = this.isGas = false;
    if (product.type === ProductType.luce) {
      this.isLight = true;
    }
    if (product.type === ProductType.gas) {
      this.isGas = true;
    }
    if (product.type === ProductType.luceEgas) {
      this.luceEgas = true
    }
  }  

  dialogInit(
    reference: ComponentRef<IModalDialog>,
    options: Partial<IModalDialogOptions<any>>
  ) {
    this.actionButtons = [
      {
        text: "",
        buttonClass: "alg-btn-close",
        onAction: () => {
          this.utils.abilityOverflow();
          return true;
        },
      },
      { text: 'Torna alla compilazione', buttonClass: 'button-cancel-product', onAction: () => {
        this.utils.abilityOverflow();
        return true;
      }
      }
    ];
    options.actionButtons = this.actionButtons;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dialogs/alg-bill-modal/alg-bill-modal.component.ts